import CachedIcon from "@mui/icons-material/Cached";
import {apiUpdateInfo} from "api/appApi";
import {useDispatch, useSelector} from "react-redux";

type Props = {};

function UpdateSetting({}: Props) {
    const dispatch = useDispatch();
    const businessState = useSelector((state: any) => state).businessReducer;
    const updateSetting = ({
                               api,
                           }: {
        api: {
            url: string;
            modelName: string;
            type?: string;
        };
    }) => {
        dispatch(
            // @ts-ignore
            apiUpdateInfo({
                token: businessState?.business?.token,
                url: api.url,
                modelName: api.modelName,
                type: api.type,
            })
        );
    };

    return (
        <div className="flex container flex-col ">
            {defaultValue.map((item, index) => (
                <div key={index} className="flex w-full flex-row item-center mb-14">
                    <div className="flex flex-1 flex-col">
                        <h1 className="text-base font-medium text-dark-6 mb-4">{item.title}</h1>
                        <span className="text-dark-3 text-xs ">{item.description}</span>
                    </div>
                    <div>
                        <button
                            onClick={() => updateSetting({api: item.api})}
                            className="py-3 px-6 rounded-md items-center mr-12 "
                        >
                            <CachedIcon className="text-white"/>
                            <span className="mr font-medium text-white mr-2 font-IRANSansMedium ">بروزرسانی</span>
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default UpdateSetting;

const defaultValue = [
    {
        title: "شماره گذاری مجدد فاکتورهای فروش",
        description: "با اجرای این عملیات، فاکتورهای فروش و پیش فاکتور مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Factor",
            type: "sale",
        },
    },
    {
        title: "شماره گذاری مجدد فاکتورهای خرید",
        description: "با اجرای این عملیات، فاکتورهای خرید مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Factor",
            type: "buy",
        },
    },
    {
        title: "شماره گذاری مجدد فاکتورهای برگشت از فروش",
        description: "با اجرای این عملیات، فاکتورهای برگشت از فروش مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Factor",
            type: "saleReturn",
        },
    },
    {
        title: "شماره گذاری مجدد فاکتورهای برگشت از خرید",
        description: "با اجرای این عملیات، فاکتورهای برگشت از خرید مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Factor",
            type: "buyReturn",
        },
    },
    {
        title: "شماره گذاری مجدد فاکتورهای ضایعات",
        description: "با اجرای این عملیات، فاکتورهای ضایعات مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Factor",
            type: "waste",
        },
    },
    {
        title: "شماره گذاری مجدد تراکنش های دریافت",
        description: "با اجرای این عملیات، تراکنش های دریافت مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Transaction",
            type: "receive",
        },
    },
    {
        title: "شماره گذاری مجدد تراکنش های پرداخت",
        description: "با اجرای این عملیات، تراکنش های پرداخت مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Transaction",
            type: "payment",
        },
    },
    {
        title: "شماره گذاری مجدد تراکنش های درآمد",
        description: "با اجرای این عملیات، تراکنش های درآمد مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Transaction",
            type: "income",
        },
    },
    {
        title: "شماره گذاری مجدد تراکنش های هزینه",
        description: "با اجرای این عملیات، تراکنش های هزینه مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Transfer",
        },
    },
    {
        title: "شماره گذاری مجدد حواله های انبار",
        description: "با اجرای این عملیات، حواله های انبار مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Bill",
        },
    },
    {
        title: "شماره گذاری مجدد اسناد حسابداری",
        description: "با اجرای این عملیات، اسناد حسابداری مجددا از شماره 1 شماره گذاری خواهند شد.",
        api: {
            url: "/sort",
            modelName: "Accounting",
        },
    },
];
